import { Component, inject, Input } from '@angular/core';
import { AuthService, PriceConfigService } from 'gung-standard';
import { first, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'otto-olsen-price-list-display',
  templateUrl: './otto-olsen-price-list-display.component.html',
  styleUrls: ['./otto-olsen-price-list-display.component.scss'],
  standalone: false
})
export class OttoOlsenPriceListDisplayComponent {
  protected priceConfigService = inject(PriceConfigService);
  protected authService = inject(AuthService);

  @Input() price;
  @Input() product;

  public Number = (n) => Number(n);

  protected unsubscribe: Subject<void> = new Subject();
  public hidePrice: boolean;

  protected isAnonymous: boolean = false;

  constructor(
  ) { }
  ngOnInit() {
    this.priceConfigService.hidePrice.pipe(takeUntil(this.unsubscribe)).subscribe(hidePrice => (this.hidePrice = hidePrice));
    this.authService.getHasRoles('ANONYMOUS').pipe(first()).subscribe(isAnonymous => this.isAnonymous = isAnonymous);
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
